import React, { createContext, useContext, useState, useMemo } from 'react';

type NavbarContextType = {
  rightContent: React.ReactNode | null;
  setRightContent: (content: React.ReactNode | null) => void;
};

const NavbarContext = createContext<NavbarContextType | undefined>(undefined);

export const NavbarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [rightContent, setRightContent] = useState<React.ReactNode | null>(null);

  const value = useMemo(
    () => ({ rightContent, setRightContent }),
    [rightContent]
  );

  return (
    <NavbarContext.Provider value={value}>
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbarContext = () => {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error('useNavbarContext must be used within NavbarProvider');
  }
  return context;
};
